// ConfettiRain.jsx
import { useEffect } from 'react';
import confetti from 'canvas-confetti';

export default function ConfettiRain() {
  useEffect(() => {
    const duration = 2.5 * 1000; // 5 seconds
    const end = Date.now() + duration;

    const interval = setInterval(() => {
      if (Date.now() > end) {
        clearInterval(interval);
        return;
      }

      confetti({
        particleCount: 5,
        startVelocity: 30,
        spread: 360,
        origin: {
          x: Math.random(),
          y: Math.random() * 0.5,
        },
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return null; // Just triggers confetti
}